module.exports = __webpack_public_path__ + "static/img/Human-performance-analysis-icon-3.98de73b4.svg";